import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
	selector: '[dragDrop]'
})
export class DragDropDirective {
	@Output() filesDropped = new EventEmitter<File[]>();
	@Output() filesDraggedOver = new EventEmitter<boolean>();
	@Output() filesDraggedLeave = new EventEmitter<boolean>();

	@HostListener('dragover', ['$event'])
	onDragOver(dragEvent: DragEvent) {
		dragEvent.preventDefault();
		dragEvent.stopPropagation();

		this.filesDraggedOver.emit(true);
	}

	@HostListener('dragleave', ['$event'])
	public onDragLeave(dragEvent: DragEvent) {
		dragEvent.preventDefault();
		dragEvent.stopPropagation();

		this.filesDraggedLeave.emit(true);
	}

	@HostListener('drop', ['$event'])
	public onDrop(dragEvent: DragEvent) {
		dragEvent.preventDefault();
		dragEvent.stopPropagation();
		if (dragEvent.dataTransfer) {
			const files = Array.from(dragEvent.dataTransfer.files);
			if (files.length) {
				this.filesDropped.emit(files);
			}
		}
	}
}
